
export default {
  props: {
    staff: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    staffMeta () {
      const meta = {};
      if (this.staff.dateOfBirth) {
        meta.dob = this.getDate(this.staff.dateOfBirth);
      }
      if (this.staff.staffType) {
        meta.team = this.staff.staffType.name;
      }
      return meta;
    },
    biography () {
      return this.staff?.biography || null;
    },
    sponsors () {
      if (this.staff.sponsors.length) {
        return this.staff.sponsors;
      }
      return null;
    },
  },
};
